import {usePageTitle, useScrollToTop} from "../hooks";
import {PublicationSection} from "../components/sections";

const Proposition = () => {
    usePageTitle('Proposer un article');
    useScrollToTop();
    return (
        <div>
            <PublicationSection />
        </div>
    );
}

export default Proposition;